{
  "header": {
    "nameShowStaticText": true,
    "nameStaticText": "Used Model: OPC 40079",
    "modelShowStaticText": false,
    "modelVariable": {
      "id": "1bf36ba5-42d7-4ee6-8ee4-47ca34d30ca5",
      "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/umati/OPC40079ForUmati/",
      "nodeId": "ns=1;i=6041",
      "displayName": "Model",
      "variablePath": "Identification.Model",
      "dataType": "LocalizedText",
      "valueRank": -1,
      "modellingRule": "Optional",
      "hasProperties": false
    }
  },
  "imagesConfig": {
    "imageDefaults": {
      "[\\s\\S]*": "pr_opc40079.jpg"
    }
  },
  "timeline": {
    "variable": {
      "id": "a836d401-f551-4367-8af6-d466e90c94e2",
      "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/umati/OPC40079ForUmati/",
      "nodeId": "ns=1;i=6005",
      "displayName": "OperationWithImmActive",
      "variablePath": "Robot.OperationWithImmActive",
      "dataType": "Boolean",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": false
    },
    "colorValues": {
      "True": "#00ff00",
      "False": "#ff0000"
    }
  },
  "sections": [
    {
      "isPlaceholder": false,
      "title": "Identification",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "showAsLink": false,
              "valueVariable": {
                "id": "d39bae39-4000-4fd2-832c-fcd001789003",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/umati/OPC40079ForUmati/",
                "nodeId": "ns=1;i=6016",
                "displayName": "ImmManufacturer",
                "variablePath": "ImmManufacturer",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Model",
              "showAsLink": false,
              "valueVariable": {
                "id": "f085d10f-3ce7-4c92-85ac-d0a230854e86",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/umati/OPC40079ForUmati/",
                "nodeId": "ns=1;i=6032",
                "displayName": "ImmModel",
                "variablePath": "ImmModel",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            }
          ],
          "title": "Injection Moulding Machine"
        },
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "showAsLink": false,
              "valueVariable": {
                "id": "a5a5af99-2d5a-4f8a-8184-52ae17e97f5c",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/umati/OPC40079ForUmati/",
                "nodeId": "ns=1;i=6033",
                "displayName": "RobotManufacturer",
                "variablePath": "RobotManufacturer",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Model",
              "showAsLink": false,
              "valueVariable": {
                "id": "792a3e60-a1a5-4f74-82e4-908b0702cef2",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/umati/OPC40079ForUmati/",
                "nodeId": "ns=1;i=6034",
                "displayName": "RobotModel",
                "variablePath": "RobotModel",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            }
          ],
          "title": "Robot"
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Monitoring",
      "rows": [
        {
          "isPlaceholder": true,
          "elements": [
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#00b20e",
                  "textColor": "#ffffff",
                  "value": "true",
                  "label": "YES"
                },
                {
                  "backgroundColor": "#c8c8c8",
                  "textColor": "#ffffff",
                  "value": "false",
                  "label": "NO"
                }
              ],
              "label": "In Position 1",
              "valueVariable": {
                "id": "1085fcad-78fb-4520-8f90-ac934a3e06c1",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/umati/OPC40079ForUmati/",
                "nodeId": "ns=1;i=6020",
                "displayName": "InPosition1",
                "variablePath": "MovablePlaten.InPosition1",
                "dataType": "Boolean",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#c8c8c8",
                  "textColor": "#ffffff",
                  "value": "0"
                },
                {
                  "backgroundColor": "#00b20e",
                  "textColor": "#ffffff",
                  "value": "1",
                  "label": "MOVING TO POSITION 2"
                },
                {
                  "backgroundColor": "#00b20e",
                  "textColor": "#ffffff",
                  "value": "2",
                  "label": "MOVING TO POSITION 1"
                }
              ],
              "label": "Movement",
              "valueVariable": {
                "id": "8fb1976d-d415-4e09-a41f-ed4b09446fbc",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/umati/OPC40079ForUmati/",
                "nodeId": "ns=1;i=6022",
                "displayName": "Movement",
                "variablePath": "MovablePlaten.Movement",
                "dataType": "MovementEnum",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#00b20e",
                  "textColor": "#ffffff",
                  "value": "true",
                  "label": "YES"
                },
                {
                  "backgroundColor": "#c8c8c8",
                  "textColor": "#ffffff",
                  "value": "false",
                  "label": "NO"
                }
              ],
              "label": "In Position 2",
              "valueVariable": {
                "id": "8e58e499-f2bc-4be7-9e24-f3e5fc7ed812",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/umati/OPC40079ForUmati/",
                "nodeId": "ns=1;i=6021",
                "displayName": "InPosition2",
                "variablePath": "MovablePlaten.InPosition2",
                "dataType": "Boolean",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            }
          ],
          "placeholderObject": "Imm.Mould_<Nr>.[PLACEHOLDER]",
          "title": "Robot Position"
        },
        {
          "isPlaceholder": true,
          "elements": [
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#00ff00",
                  "textColor": "#ffffff",
                  "value": "true",
                  "label": "YES"
                },
                {
                  "backgroundColor": "#ff0000",
                  "textColor": "#ffffff",
                  "value": "false",
                  "label": "NO"
                }
              ],
              "label": "Enable to Position 1",
              "valueVariable": {
                "id": "8217cfdd-dcbe-419d-b7ba-227eaae9960f",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/umati/OPC40079ForUmati/",
                "nodeId": "ns=1;i=6023",
                "displayName": "EnableToPosition1",
                "variablePath": "EnableMovablePlaten.EnableToPosition1",
                "dataType": "Boolean",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#00ff00",
                  "textColor": "#ffffff",
                  "value": "true",
                  "label": "YES"
                },
                {
                  "backgroundColor": "#ff0000",
                  "textColor": "#ffffff",
                  "value": "false",
                  "label": "NO"
                }
              ],
              "label": "Mould Area Free",
              "valueVariable": {
                "id": "7f3f6f62-d3fb-4527-8108-0b80ed2b61cb",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/umati/OPC40079ForUmati/",
                "nodeId": "ns=1;i=6018",
                "displayName": "MouldAreaFree",
                "variablePath": "MouldAreaFree",
                "dataType": "Boolean",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#00ff00",
                  "textColor": "#ffffff",
                  "value": "true",
                  "label": "YES"
                },
                {
                  "backgroundColor": "#ff0000",
                  "textColor": "#ffffff",
                  "value": "false",
                  "label": "NO"
                }
              ],
              "label": "Enable to Position 2",
              "valueVariable": {
                "id": "19f91cb2-ead7-4314-a7ca-f89e9d3102c8",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/umati/OPC40079ForUmati/",
                "nodeId": "ns=1;i=6024",
                "displayName": "EnableToPosition2",
                "variablePath": "EnableMovablePlaten.EnableToPosition2",
                "dataType": "Boolean",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            }
          ],
          "placeholderObject": "Robot.MouldInteraction_<Nr>.[PLACEHOLDER]",
          "title": "Robot Movement Authorization"
        },
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Robot Message send",
              "showAsLink": false,
              "valueVariable": {
                "id": "874fcf3e-377b-49f2-82e9-b099fd0f2caa",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/umati/OPC40079ForUmati/",
                "nodeId": "ns=1;i=6008",
                "displayName": "RobotMessageId",
                "variablePath": "Robot.RobotMessageId",
                "dataType": "UInt32",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false,
                "hasUnit": false,
                "hasRange": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "IMM Message confirmed",
              "showAsLink": false,
              "valueVariable": {
                "id": "364ca620-d435-4b84-9dc5-e69ab0640650",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/umati/OPC40079ForUmati/",
                "nodeId": "ns=1;i=6004",
                "displayName": "RobotMessageId_confirmed",
                "variablePath": "Imm.RobotMessageId_confirmed",
                "dataType": "UInt32",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false,
                "hasUnit": false,
                "hasRange": false
              }
            }
          ],
          "title": "Information exchange between Robot and Injection Moulding Machine"
        }
      ]
    }
  ]
}
